import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { UserListComponent } from './user-list.component';
import { UserListTableComponent } from './components/user-list-table/user-list-table.component';
import { InviteUsersDialogComponent } from './dialog/invite-users-dialog/invite-users-dialog.component';
import { UserDelegateDialogComponent } from './dialog/user-delegate-dialog/user-delegate-dialog.component';

@NgModule({
  declarations: [UserListComponent, UserListTableComponent, InviteUsersDialogComponent, UserDelegateDialogComponent],
  imports: [CommonModule, SharedModule],
})
export class UserListModule {}
